import React, { useState } from "react";
import { X, Loader2, Truck } from "lucide-react";
import { toast } from "sonner";
import axios from "axios";
import { API, authHeaders } from "./shared";

export default function CreateShipmentForm({ request, onClose, onSave }) {
  const [creating, setCreating] = useState(false);
  const dest = request.destination || {};

  const handleCreate = async () => {
    setCreating(true);
    try {
      const r = await axios.post(`${API}/admin/warehouse/requests/${request.id}/create-shipment`, {}, authHeaders());
      toast.success(`Spedizione ${r.data.tracking_number} creata`);
      onClose();
      onSave();
    } catch (err) { toast.error(err.response?.data?.detail || "Errore creazione spedizione"); }
    setCreating(false);
  };

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-start justify-center pt-16 overflow-y-auto">
      <div className="bg-white rounded-sm w-full max-w-md shadow-xl m-4" data-testid="create-shipment-form">
        <div className="flex items-center justify-between px-6 py-4 border-b border-zinc-200">
          <h2 className="font-heading font-bold text-lg uppercase tracking-wide">Crea Spedizione</h2>
          <button onClick={onClose} className="p-2 text-zinc-400 hover:text-zinc-600"><X size={20} /></button>
        </div>
        <div className="p-6 space-y-4">
          <p className="text-sm text-zinc-600">Verra creata una nuova spedizione tracciata partendo dai dati di questa richiesta:</p>

          <div className="bg-zinc-50 rounded-sm p-3 space-y-2 text-xs">
            <div><span className="font-bold uppercase text-zinc-500">Cliente:</span> {request.company || request.client_name}</div>
            <div><span className="font-bold uppercase text-zinc-500">Articoli:</span> {request.items?.length || 0}</div>
            <div><span className="font-bold uppercase text-zinc-500">Origine:</span> Magazzino MV — Castiglione delle Stiviere (MN)</div>
            <div><span className="font-bold uppercase text-zinc-500">Destinazione:</span> {dest.name || "-"} {dest.company ? `(${dest.company})` : ""}<br/>
              {dest.address || ""} — {[dest.cap, dest.city, dest.province].filter(Boolean).join(" ")}<br/>
              {dest.phone ? `Tel: ${dest.phone}` : ""}
            </div>
          </div>

          <div className="bg-amber-50 border-l-2 border-amber-400 px-3 py-2 text-xs text-amber-800">
            Dopo la creazione potrai assegnare autista, modificare colli e tariffe dalla sezione <b>Spedizioni</b>.
          </div>

          <div className="flex gap-2">
            <button onClick={onClose} className="flex-1 border border-zinc-200 text-zinc-600 h-10 rounded-sm text-sm font-bold uppercase hover:bg-zinc-50">
              Annulla
            </button>
            <button onClick={handleCreate} disabled={creating} data-testid="confirm-shipment-btn"
              className="flex-1 bg-[#FF5200] text-white h-10 rounded-sm text-sm font-bold uppercase hover:bg-[#e64a00] disabled:opacity-50 flex items-center justify-center gap-2">
              {creating ? <Loader2 size={14} className="animate-spin" /> : <Truck size={14} />}
              Crea Spedizione
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
